













































import {Component, Vue} from 'vue-property-decorator';
import {cloneDeep, isEqual} from 'lodash';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CConfirmDialog from '@/components/base/dialog/CConfirmDialog.vue';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
    components: {CConfirmDialog, CCheckbox, CSimpleTable},
})
export default class UserRoleLink extends Vue {
    private loading: boolean = false;
    private data: any = null;
    private items: any = null;
    private initialItems: any = null;

    get hasUnsavedChanges() {
        return !isEqual(this.items, this.initialItems);
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    created() {
        this.getData();
    }
    beforeRouteLeave(to: any, from: any, next: any) {
        if (this.hasUnsavedChanges)
            (this.$refs.confirm as any).open(
                {
                    text: 'У вас есть несохраненные изменения, вы уверены, что хотите перейти?',
                },
                {
                    callback: () => {
                        next();
                    },
                },
            );
        else next();
    }

    async getData() {
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.get(`${this.$api.administration.userRoleLink}/GetAll`, {
                params: {
                    ...this.$route.query,
                },
            });
            this.data = data;
            this.items = this.getItems(data);
            this.initialItems = cloneDeep(this.items);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    getItems(data: any) {
        let Rows = data.Rows;
        let Columns = data.Columns;
        let Items = data.Items;
        let result = [];

        for (let i = 0; i < Rows.length; i++) {
            let row = [];
            for (let j = 0; j < Columns.length; j++) {
                let cell: any = {
                    IdColumn: Columns[j].Id,
                    IdRow: Rows[i].Id,
                    Id: j + 1,
                };
                let checked: boolean = false;
                let index = Items.findIndex(
                    (item: any) => item.IdColumn === cell.IdColumn && item.IdRow === cell.IdRow,
                );

                if (index > -1) checked = true;

                cell.checked = checked;
                cell.checkLoadState = checked;

                row.push(cell);
            }

            result.push(row);
        }
        return result;
    }

    reset() {
        this.items = cloneDeep(this.initialItems);
    }

    async save() {
        if (!this.hasUnsavedChanges) return;
        let result = [];
        for (let i = 0; i < this.items.length; i++) {
            let row = this.items[i];
            for (let j = 0; j < row.length; j++) {
                let cell = row[j];
                if (cell.checked) {
                    let {IdColumn, IdRow} = cell;
                    result.push({IdColumn, IdRow});
                }
            }
        }
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.post(`${this.$api.administration.userRoleLink}/Save`, result, {
                params: {
                    ...this.$route.query,
                },
            });
            this.data = data;
            this.items = this.getItems(data);
            this.initialItems = cloneDeep(this.items);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
}
